export default {
    loading: false,
    items: 0,
}